import generateTypes from '../../utils/generateTypes';

export const GET_TASKS = generateTypes('GET_TASKS');
export const RESET_TASKS = generateTypes('RESET_TASKS');
